export default __webpack_public_path__ + "static/media/IISC.828edf6d.png";